"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2934],{

/***/ 301831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Z": function() { return /* binding */ Card7; },
/* harmony export */   "CQ": function() { return /* binding */ Card11; },
/* harmony export */   "GL": function() { return /* binding */ Card3; },
/* harmony export */   "P": function() { return /* binding */ Card9; },
/* harmony export */   "Pe": function() { return /* binding */ Card13; },
/* harmony export */   "_7": function() { return /* binding */ Card12; },
/* harmony export */   "st": function() { return /* binding */ Card1; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(186812);
/* harmony import */ var _utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(336623);
/* harmony import */ var _utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828631);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(326706);






var Card1 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var ref;
    // const { deviceWidth } = IS_SERVER ? { deviceWidth: 0 } : getDeviceInfo();
    // const style = {
    //   height: widgetConfig.card_cta_visibility
    //     ? deviceWidth < 900
    //       ? '400px'
    //       : widgetConfig?.image_dimension?.height
    //     : widgetConfig?.image_dimension?.height,
    //   minWidth: widgetConfig.card_cta_visibility
    //     ? deviceWidth < 900
    //       ? '300px'
    //       : '750px'
    //     : '300px',
    // };
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "category-card-1",
        // style={style}
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                    backgroundSize: "cover"
                },
                className: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "category-name tc",
                children: category.name ? category.name : "Available Items"
            }),
            (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.card_cta_visibility) && (!horizontal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "category-btn db-ns dn",
                children: theme === null || theme === void 0 ? void 0 : (ref = theme.cta_config) === null || ref === void 0 ? void 0 : ref.banner_cta
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "horizontal-category-btn db-ns dn",
                children: (0,_utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("widget_cta")
            }))
        ]
    }, key);
};
var Card3 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "category-card-3",
        // style={{ height: widgetConfig.image_dimension.height }}
        style: {
            height: "auto"
        },
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: (0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                    theme: theme,
                    item: category
                })
            }),
            (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.card_cta_visibility) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "category-btn",
                children: category.name ? category.name : "Available Items"
            })
        ]
    }, key);
};
var Card7 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, cardIndx = param.cardIndx, onClick = param.onClick, skewDirection = param.skewDirection;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    var skewAngle = _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_2__/* .deviceWidth */ .o > 990 ? 15 : 5;
    var skew = {
        right: "skew(".concat(skewAngle, "deg)"),
        left: "skew(-".concat(skewAngle, "deg)")
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "category-card-7",
        style: {
            // height: widgetConfig.image_dimension.height,
            transform: skew[skewDirection]
        },
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                    backgroundSize: "cover"
                }
            }),
            (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.card_cta_visibility) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "category-btn ",
                children: category.name ? category.name : "Available Items"
            })
        ]
    }, cardIndx);
};
var Card9 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "category-card-9",
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%")
                },
                className: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "category-name tc",
                children: category.name ? category.name : "Available Items"
            }),
            (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.card_cta_visibility) && (!horizontal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "category-btn db-ns dn",
                children: "Explore"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "horizontal-category-btn db-ns dn",
                children: "Explore"
            }))
        ]
    }, key);
};
var Card11 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "category-card-11 ".concat(horizontal ? "horizontal-card" : ""),
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                    backgroundPosition: "center",
                    backgroundSize: "contain"
                },
                className: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "category-name tc mv0",
                children: category.name ? category.name : "Available Items"
            })
        ]
    }, key);
};
var Card12 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "category-card-12 ".concat(horizontal ? "horizontal-card" : ""),
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                    backgroundPosition: "center",
                    backgroundSize: "contain"
                },
                className: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "category-name tc mv0",
                children: category.name ? category.name : "Available Items"
            })
        ]
    }, key);
};
var Card13 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "category-card-13 ".concat(horizontal ? "horizontal-card" : ""),
        onClick: function() {
            return onClick(category);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative w-100",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                            theme: theme,
                            item: category
                        }), ")"),
                        paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%")
                    },
                    className: "image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "category-name tc mv0 z-5",
                    style: {
                        paddingTop: "calc(".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "% - 29px)")
                    },
                    children: category.name ? category.name : "Available Items"
                })
            ]
        })
    }, key);
};


/***/ }),

/***/ 932934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _cards__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(301831);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(540190);
/* harmony import */ var _utils_returnCommonConfigData__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(943090);
/* harmony import */ var _utils_calculateArrowTopPos__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(471386);
/* harmony import */ var _utils_showViewMoreBtn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(752925);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(326706);
/* harmony import */ var src_containers_Collections_useGetTypeIdFromCanonicalDataStore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(130553);










var CategoryWidget = function(props) {
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var typeId = (0,src_containers_Collections_useGetTypeIdFromCanonicalDataStore__WEBPACK_IMPORTED_MODULE_6__/* .useGetTypeIdFromCanonicalDataStore */ .C)().typeId;
    var hideCategoryId = typeId;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), widgetConfig = ref2[0], setWidgetConfig = ref2[1];
    var ref3 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return {
            catalogCategories: state.catalogReducer.categories,
            storeData: state.storeReducer.store
        };
    }), catalogCategories = ref3.catalogCategories, storeData = ref3.storeData;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (props.config) {
            setWidgetConfig(props.config);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var element = document.getElementById("scroll-wrapper-".concat((props === null || props === void 0 ? void 0 : props.cardType) || 0));
        var arrowEle = document.getElementsByClassName("arrow-btns");
        var eleChildren = Array.from(element.children);
        var totalWidth = 0;
        for(var i = 0; i < eleChildren.length; i++){
            totalWidth += eleChildren[i].offsetWidth;
        }
        if (element.offsetWidth > totalWidth) {
            Array.from(arrowEle).map(function(arrow) {
                return arrow.classList.add("dn");
            });
        }
    }, [
        catalogCategories
    ]);
    var onCategoryItemClick = function(category) {
        var ref;
        window.location.href = (0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)("".concat(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.SHOP, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain);
    };
    var onViewMoreCtaClick = function() {
        var ref;
        router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)("".concat(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.CATEGORIES), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var _renderCategoryCard = function(category, idx, cardNumer) {
        switch(cardNumer){
            case 2:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_3__/* .Card1 */ .st, {
                    category: category,
                    widgetConfig: widgetConfig,
                    onClick: onCategoryItemClick,
                    horizontal: true
                }, idx);
            case 4:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_3__/* .Card3 */ .GL, {
                    category: category,
                    widgetConfig: widgetConfig,
                    onClick: onCategoryItemClick
                }, idx);
            case 8:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_3__/* .Card7 */ .$Z, {
                    category: category,
                    cardIndx: idx,
                    widgetConfig: widgetConfig,
                    onClick: onCategoryItemClick,
                    skewDirection: "left"
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_3__/* .Card1 */ .st, {
                    category: category,
                    widgetConfig: widgetConfig,
                    onClick: onCategoryItemClick
                }, idx);
        }
    };
    var scrollNewReleaseSection = function(scrollType, SRType) {
        var scrollMovPos = 330;
        var element = document.getElementById("scroll-wrapper-".concat(SRType));
        var leftArrowEle = document.getElementsByClassName("modal-left-arrow-".concat(SRType));
        var rightArrowEle = document.getElementsByClassName("modal-right-arrow-".concat(SRType));
        var scrollPos = 0;
        if (element) {
            scrollPos = element.scrollLeft;
            if (scrollType === "left") {
                if (scrollPos < 130) scrollPos = 0;
                else scrollPos -= scrollMovPos;
            } else {
                scrollPos += scrollMovPos;
            }
            if (scrollPos >= 0) {
                element.scrollLeft = scrollPos;
                if (leftArrowEle) {
                    !scrollPos ? leftArrowEle[0].classList.add("dn") : leftArrowEle[0].classList.remove("dn");
                }
                if (rightArrowEle) {
                    if (scrollPos + element.offsetWidth >= element.scrollWidth) {
                        rightArrowEle[0].classList.add("dn");
                    } else {
                        rightArrowEle[0].classList.remove("dn");
                    }
                }
            }
        }
    };
    /**
   * return categories array. if max_limit exist in config, limit array size to max_limit.
   * @return {*} array
   */ var getCategoriesList = function() {
        var arr = [];
        if (catalogCategories.length > 0) if (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.max_limit) {
            arr = catalogCategories === null || catalogCategories === void 0 ? void 0 : catalogCategories.slice(0, widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.max_limit);
        } else {
            return catalogCategories;
        }
        return arr;
    };
    var returnCardOffsetWidth = function() {
        if (true) {
            // get specific scroll wrapper
            var scrollwr = document === null || document === void 0 ? void 0 : document.querySelector("#scroll-wrapper-".concat((props === null || props === void 0 ? void 0 : props.cardType) || 0));
            // get first horizontal card to get offset height
            var card = scrollwr === null || scrollwr === void 0 ? void 0 : scrollwr.querySelector(".horizontal-card");
            if (card) return card.offsetWidth;
        }
        return null;
    };
    /**
   * calculate Y axis position in px of left and right arrows
   * @return {*} number
   */ var arrowTopPos = function() {
        return (0,_utils_calculateArrowTopPos__WEBPACK_IMPORTED_MODULE_7__/* .calculateArrowTopPos */ .K)((0,_utils_returnCommonConfigData__WEBPACK_IMPORTED_MODULE_8__/* .returnCommonConfigData */ .Z)({
            productConfig: props === null || props === void 0 ? void 0 : props.config
        }), returnCardOffsetWidth());
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "horizontal-CategoryWidget relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "tl title fw6 ph3 ph4-ns tc",
                children: (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.heading) || "View More Categories"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative",
                children: [
                    (catalogCategories === null || catalogCategories === void 0 ? void 0 : catalogCategories.length) > 1 && !props.noArrows && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                style: {
                                    top: arrowTopPos()
                                },
                                alt: "Left Button",
                                src: "/assets/icons/arrowLeftIconCircleDark.png",
                                className: "modal-left-arrow-".concat((props === null || props === void 0 ? void 0 : props.cardType) || 0, " arrow-btns absolute left-1-ns left-0 img pointer dn"),
                                onClick: function() {
                                    return scrollNewReleaseSection("left", (props === null || props === void 0 ? void 0 : props.cardType) || 0);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                style: {
                                    top: arrowTopPos()
                                },
                                alt: "Right Button",
                                src: "/assets/icons/arrowRightIconCircleDark.png",
                                className: "modal-right-arrow-".concat((props === null || props === void 0 ? void 0 : props.cardType) || 0, " arrow-btns absolute right-1-ns right-0 img pointer"),
                                onClick: function() {
                                    return scrollNewReleaseSection("right", (props === null || props === void 0 ? void 0 : props.cardType) || 0);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: "scroll-wrapper ".concat(props.customScrollClass ? "custom-scroll" : ""),
                        id: "scroll-wrapper-".concat((props === null || props === void 0 ? void 0 : props.cardType) || 0),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "ml1 ml5-ns ph2 ph5-ns"
                            }),
                            ((ref = getCategoriesList()) === null || ref === void 0 ? void 0 : ref.length) > 0 && getCategoriesList().map(function(category, index) {
                                return category.id !== Number(hideCategoryId) ? _renderCategoryCard(category, index, props.cardType) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                            }),
                            (0,_utils_showViewMoreBtn__WEBPACK_IMPORTED_MODULE_9__/* .showViewMoreBtn */ .M)(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.max_limit, catalogCategories) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                                className: "category-card pointer flex items-start view-more-box",
                                onClick: onViewMoreCtaClick,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "view-more-box--inner relative",
                                    style: {
                                        paddingTop: "".concat((widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio) || 10000 / (storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.product_aspect_ratio) || 100, "%")
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            "View More",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "ml1 ml5-ns ph2 ph5-ns"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoryWidget);


/***/ }),

/***/ 130553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useGetTypeIdFromCanonicalDataStore; }
/* harmony export */ });
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(268037);
/* harmony import */ var src_utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);


var useGetTypeIdFromCanonicalDataStore = function() {
    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var ref;
    var canonicalData = (0,src_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSSRSelector */ .kF)(function(state) {
        return state.catalogReducer.canonicalData;
    });
    return {
        typeId: +id || +(canonicalData === null || canonicalData === void 0 ? void 0 : (ref = canonicalData.item_group_details) === null || ref === void 0 ? void 0 : ref.id),
        isTypeCollection: (canonicalData === null || canonicalData === void 0 ? void 0 : canonicalData.type) === src_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_TYPE_ID.COLLECTION */ .Rv.COLLECTION,
        isTypeCategory: (canonicalData === null || canonicalData === void 0 ? void 0 : canonicalData.type) === src_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_TYPE_ID.CATEGORY */ .Rv.CATEGORY,
        isTypeTags: (canonicalData === null || canonicalData === void 0 ? void 0 : canonicalData.type) === src_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_TYPE_ID.TAG */ .Rv.TAG
    };
};


/***/ }),

/***/ 471386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ calculateArrowTopPos; }
/* harmony export */ });
/**
 * function to calculate Y-axis position of arrow
 * considering the dynamic acpect ratio of card
 * if card offset width is not 300, calculate card width
 *
 * @param {*} commonConfigData
 * @param {*} cardHeight
 * @return {*} string
 */ var calculateArrowTopPos = function() {
    var commonConfigData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cardHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
    var _aspect_ratio = commonConfigData.aspect_ratio, aspect_ratio = _aspect_ratio === void 0 ? null : _aspect_ratio;
    if (!aspect_ratio) return "50%";
    var height = cardHeight * (aspect_ratio / 100) / 2;
    return height ? "".concat(height, "px") : "50%";
};


/***/ }),

/***/ 940619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hp": function() { return /* binding */ imgSizeEnums; },
/* harmony export */   "N7": function() { return /* binding */ getMaxImgSizeForComponent; },
/* harmony export */   "VW": function() { return /* binding */ getSrcSetFromCompressedImages; },
/* harmony export */   "Xx": function() { return /* binding */ componentTypeEnums; },
/* harmony export */   "vb": function() { return /* binding */ getImageUrlFromCompressedImages; }
/* harmony export */ });
var componentTypeEnums = {
    CARD: 1,
    ITEM_THUMBNAIL: 2
};
var imgSizeEnums = {
    LOW: 1,
    MID: 2,
    HIGH: 3
};
// the srcset is creating a few problems where device pixel ratio is high (loading a lower resolution image)
// consider using getImageUrlFromCompressedImages for any such cases
function getSrcSetFromCompressedImages() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, extraFields = arguments.length > 2 ? arguments[2] : void 0;
    var parsedCompressedImages = parseCompressedImageObj(compressedImages || {});
    return prepareSrcSet(parsedCompressedImages, mainImage, (extraFields === null || extraFields === void 0 ? void 0 : extraFields.maxImgSize) || imgSizeEnums.HIGH, (extraFields === null || extraFields === void 0 ? void 0 : extraFields.minImgSize) || imgSizeEnums.LOW);
}
function getImageUrlFromCompressedImages() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, extraFields = arguments.length > 2 ? arguments[2] : void 0;
    var parsedCompressedImages = parseCompressedImageObj(compressedImages || {});
    var screenWidth =  false ? 0 : window.innerWidth;
    var maxImgSize = (extraFields === null || extraFields === void 0 ? void 0 : extraFields.maxImgSize) || imgSizeEnums.HIGH;
    var urlToReturn = mainImage;
    if (parsedCompressedImages[imgSizeEnums.LOW] && (screenWidth <= 320 || maxImgSize === imgSizeEnums.LOW)) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.LOW];
    } else if (parsedCompressedImages[imgSizeEnums.MID] && (screenWidth > 320 && screenWidth < 768 || maxImgSize === imgSizeEnums.MID)) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.MID];
    } else if (parsedCompressedImages[imgSizeEnums.HIGH]) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.HIGH];
    }
    return urlToReturn;
}
function prepareSrcSet() {
    var imgObj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, maxImgSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : imgSizeEnums.HIGH, minImgSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : imgSizeEnums.LOW;
    var resString = "";
    var dpr =  false ? 0 : window.devicePixelRatio;
    if (minImgSize <= imgSizeEnums.LOW && maxImgSize >= imgSizeEnums.LOW && imgObj[imgSizeEnums.LOW]) {
        resString += "".concat(imgObj[imgSizeEnums.LOW], " ").concat(320 * dpr, "w, ");
    }
    if (minImgSize <= imgSizeEnums.MID && maxImgSize >= imgSizeEnums.MID && imgObj[imgSizeEnums.MID]) {
        resString += "".concat(imgObj[imgSizeEnums.MID], " ").concat(480 * dpr, "w, ");
    }
    if (minImgSize <= imgSizeEnums.HIGH && maxImgSize >= imgSizeEnums.HIGH && imgObj[imgSizeEnums.HIGH]) {
        resString += "".concat(imgObj[imgSizeEnums.HIGH], " ").concat(768 * dpr, "w, ");
    }
    if (!maxImgSize || !resString) {
        resString += "".concat(mainImage);
    }
    return resString;
}
// returns Object with image urls corresponding to low medium and high which is Represented by 1,2,3
function parseCompressedImageObj() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var res = {};
    var keys = Object.keys(compressedImages) // keys are strings where numbers are separated by *. Eg. "200*200"
    ;
    // sorting keys (eg. key=200*200) to handle the case when we get jumbled order of image sizes.
    keys.sort(function(a, b) {
        var first = parseInt(a.split("*")[0]);
        var second = parseInt(b.split("*")[0]);
        return first - second;
    });
    if (keys.length >= 1) {
        res[imgSizeEnums.LOW] = compressedImages[keys[0]];
    }
    if (keys.length >= 2) {
        res[imgSizeEnums.MID] = compressedImages[keys[1]];
    }
    if (keys.length >= 3) {
        res[imgSizeEnums.HIGH] = compressedImages[keys[2]];
    }
    return res;
}
function getMaxImgSizeForComponent(componentType) {
    if (componentType === componentTypeEnums.CARD) {
        return imgSizeEnums.MID;
    } else if (componentType === componentTypeEnums.ITEM_THUMBNAIL) {
        return imgSizeEnums.LOW;
    }
    return imgSizeEnums.MID;
}


/***/ }),

/***/ 943090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ returnCommonConfigData; }
/* harmony export */ });
/**
 * common function to return config data for card configuration changes
 * @param {*} {activeCategoryConfig, productConfig}
 * @return {*} object - config
 */ var returnCommonConfigData = function(param) {
    var _activeCategoryConfig = param.activeCategoryConfig, activeCategoryConfig = _activeCategoryConfig === void 0 ? {} : _activeCategoryConfig, _productConfig = param.productConfig, productConfig = _productConfig === void 0 ? {} : _productConfig;
    if (activeCategoryConfig && Object.keys(activeCategoryConfig).length > 0) {
        return activeCategoryConfig;
    } else if (productConfig && Object.keys(productConfig).length > 0) {
        return productConfig;
    } else {
        return {};
    }
};


/***/ }),

/***/ 828631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ returnSpecificImageUrl; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);
/* harmony import */ var _compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(940619);


/*
 returns either image_url or thumbnail_url,
 depending on the configuration of theme config 'product_image_quality_flag'
 */ function returnSpecificImageUrl(param) {
    var theme = param.theme, item = param.item;
    if (!theme || !(theme === null || theme === void 0 ? void 0 : theme.product_image_quality_flag)) return (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getImageUrlFromCompressedImages */ .vb)(item === null || item === void 0 ? void 0 : item.compressed_images, item === null || item === void 0 ? void 0 : item.image_url, {
        maxImgSize: (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getMaxImgSizeForComponent */ .N7)(_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .componentTypeEnums.CARD */ .Xx.CARD)
    });
    return (theme === null || theme === void 0 ? void 0 : theme.product_image_quality_flag) === _constants__WEBPACK_IMPORTED_MODULE_0__/* .IMAGE_CONFIG_CONSTANT.THUMBNAIL_IMAGE */ .of.THUMBNAIL_IMAGE ? (item === null || item === void 0 ? void 0 : item.thumbnail_url) || (item === null || item === void 0 ? void 0 : item.image_url) : (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getImageUrlFromCompressedImages */ .vb)(item === null || item === void 0 ? void 0 : item.compressed_images, item === null || item === void 0 ? void 0 : item.image_url, {
        maxImgSize: (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getMaxImgSizeForComponent */ .N7)(_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .componentTypeEnums.CARD */ .Xx.CARD)
    });
}


/***/ }),

/***/ 752925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ showViewMoreBtn; }
/* harmony export */ });
/**
 * returns boolean. conditionally render View More button
 * based on maxLimit and item list
 * @param {*} maxLimit number
 * @param {*} itemList array
 * @return {*} boolean
 */ var showViewMoreBtn = function() {
    var maxLimit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, itemList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (!maxLimit && !(itemList === null || itemList === void 0 ? void 0 : itemList.length)) return false;
    return maxLimit ? (itemList === null || itemList === void 0 ? void 0 : itemList.length) > maxLimit : false;
};


/***/ })

}]);